<template>
  <div
    style="max-height: 75vh;
    overflow-y: auto; overflow-x: hidden;"
    id="filter-modal"
  >
    <date-blocks class="mt-4" />>
    <v-row class="mx-9">
      <v-autocomplete
        clearable
        filled
        label="City"
        class="pt-0"
        id="filter-city-dropdown"
        dense
        :items="_filterOptions.cities"
        color="secondary"
        v-model="filterParams.city"
      ></v-autocomplete>
    </v-row>
    <v-row class="mx-9">
      <v-autocomplete
        clearable
        filled
        id="filter-group-dropdown"
        :label="groupLabel"
        dense
        :items="groupOptions"
        color="secondary"
        v-model="filterParams.group"
      ></v-autocomplete>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import FilterParams from '@/mixins/FilterParams';
import DateBlocks from './DateBlocks.vue';

export default {
  components: { DateBlocks },
  mixins: [FilterParams],
  data() {
    return {
      startMenu: false,
      endMenu: false,
      rules: {
        afterStart: () => moment(this.filterParams.start_date).isSameOrBefore(
          moment(this.filterParams.end_date),
        ) || 'End date must be later than start date',
      },
    };
  },
  computed: {
    ...mapGetters({
      _filterOptions: 'filters/getHomeFilterOptions',
      _areas: 'areas/getAreas',
    }),
    groupLabel() {
      if (this._client.client_name != 'shark') {
        return 'Group Name';
      }
      return 'Course Name';
    },
    groupOptions() {
      this._filterOptions.groups.map((group) => {
        group.text = group.text
          .toLowerCase()
          .split(' ')
          .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
          .join(' ');
      });
      return this._filterOptions.groups;
    },
  },
};
</script>
